import React, { useEffect } from 'react';
import get from 'lodash/get';
import moment from 'moment';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import { lang } from '~/commons/config';

const UserProfile = () => {
  const [userRes, userReq] = useHttpStatus();
  const [compRes, compReq] = useHttpStatus();

  useEffect(() => {
    userReq({ url: 'api/core/users/self' });
    compReq({ url: 'api/quiz/competitions/self' });
  }, []);

  return (
    <PageHttp res={[userRes, compRes]}>
      {([user, comp]) => {
        const answer = comp.answers[0];
        const inProgress = answer
          && !answer.submittedAt
          && moment(answer.createdAt)
            .add(comp.duration, 'm')
            .isAfter();
        let duration = 0;

        if (answer && !inProgress) {
          duration = moment.duration(user.comp.duration);
        }

        return (
          <div className="container-fluid px-md-4 py-5">
            <h3>{lang(user.name.full)}</h3>
            <h6>{user.username}</h6>
            <h6>
              {
                [
                  get(user, 'schoolClass.title'),
                  lang(get(user, 'school.title')),
                ].join(' . ')
              }
            </h6>
            <img
              style={{ width: '60px' }}
              className="py-3"
              src={`assets/img/file-${
                answer && !inProgress ? 'checked.svg' : 'warning.png'
              }`}
            />

            {!answer && (
              <div className="text-secondary">未有作答記錄</div>
            )}
            {inProgress && (
              <div className="text-secondary">問答進行中</div>
            )}
            {answer && !inProgress && (
              <div>
                於
                <span className="text-secondary">
                  {moment(answer.updatedAt).format('LL')}
                </span>
                作答
                <br />
                用時
                <span className="text-secondary">
                  {duration.minutes()}分{duration.seconds()}秒
                </span>
              </div>
            )}
          </div>
        );
      }}
    </PageHttp>
  );
};

export default UserProfile;
